fragment ChangelogEventFragment on TimelineEvent {
    changeType
    changeTime
    description
    actor {
        ... on User {
            id
            name
        }
        ... on Origin {
            id
            name
        }
    }
    origin {
        id
        name
    }
    changes {
        description
    }
    automations {
        humanReadableDescription
    }
}
